import { Component, computed, inject, input } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectWebsocketStatus } from '../+state/events/events.reducer';
import { PulsingIndicatorComponent } from '../../components/pulsing-indicator';
import { WebsocketStatusEnum } from '../../constants/websocket-status';

@Component({
    selector: 'sphere-shell-ws-status',
    template: `
        @if (!onlyErrors() || isNonIdealStatus()) {
            <div class="ws-status__container">
                <sphere-pulsing-indicator
                    size="xsmall"
                    [color]="webSocketStatusColor()"
                    shape="circle"
                    [animation]="webSocketStatusAnimation()"
                ></sphere-pulsing-indicator>
                <p class="ws-status__label">{{ webSocketStatusLabel() }}</p>
            </div>
        }
    `,
    styles: [
        `
            .ws-status__container {
                display: flex;
                flex-direction: row;
                align-items: center;
            }
            .ws-status__label {
                font-family: var(--font-family-roboto);
                font-weight: 500;
                font-size: 9px;
                color: #979797;
                margin-left: -3px;
            }
        `
    ],
    imports: [PulsingIndicatorComponent]
})
export class WsStatusComponent {
    private store = inject(Store);
    public webSocketStatus = this.store.selectSignal(selectWebsocketStatus);

    public readonly onlyErrors = input<boolean>(false);
    // public readonly webSocketStatus = input<WebsocketStatusType | undefined>();

    public readonly webSocketStatusColor = computed(() => {
        switch (this.webSocketStatus()) {
            case WebsocketStatusEnum.open:
                return 'green';
            case WebsocketStatusEnum.connecting:
                return 'yellow';
            case WebsocketStatusEnum.closed:
                return 'red';
            case WebsocketStatusEnum.closing:
                return 'orange';
            default:
                return 'darkgray';
        }
    });

    public readonly webSocketStatusAnimation = computed(() => {
        switch (this.webSocketStatus()) {
            case WebsocketStatusEnum.open:
            case WebsocketStatusEnum.connecting:
            case WebsocketStatusEnum.closing:
                return 'pulse';
            case WebsocketStatusEnum.closed:
            default:
                return 'none';
        }
    });
    public readonly webSocketStatusLabel = computed(() => {
        switch (this.webSocketStatus()) {
            case WebsocketStatusEnum.open:
                return 'Real time data available';
            case WebsocketStatusEnum.connecting:
                return 'Connecting to real time data';
            case WebsocketStatusEnum.closed:
                return 'Offline';
            case WebsocketStatusEnum.closing:
                return 'Disconnecting from real time data';
            default:
                return 'Unknown';
        }
    });
    public readonly isNonIdealStatus = computed(() => {
        switch (this.webSocketStatus()) {
            case WebsocketStatusEnum.closed:
            case WebsocketStatusEnum.closing:
            case WebsocketStatusEnum.connecting:
                return true;
            case WebsocketStatusEnum.open:
                return false;
            default:
                return true;
        }
    });
}
